import { adminFetch } from './dataProvider';

/**
 * Starts a CRM OAuth connect flow. The backend returns an authorization URL
 * to send the browser to (a full-page navigation, not XHR); the provider's
 * own redirect_uri lands back on this SPA's `/integrations` route with
 * `?connected=<source>` or `?error=<code>` (see IntegrationsPage).
 */
export const crmOauthStart = (source: string): Promise<{ url: string }> =>
  adminFetch<{ url: string }>(`/v1/admin/crm/${source}/oauth/start`);
